import React from "react";
import { makeStyleguideTemplate } from "tsi-common-react/src/styleguide/makeStyleguideTemplate";

import { templates } from "@reactivated";

import {
    buildComparePageBodyComponentsMap,
    buildContextualToolboxComponentsMap,
    buildHomePageComponentsMap,
    buildProductComparePageComponentsMap,
    buildProductPageBaseComponentsMap,
    compareHeroComponentsMap,
    configuratorPromoLineComponentsMap,
    faqPageComponentsMap,
    financingPageComponentsMap,
    footerComponentsMap,
    offersPageComponentsMap,
    promoModalComponentsMap,
    reviewsRightBarComponentsMap,
} from "../blocks/componentMaps";
import { StyleguideChrome } from "../components/StyleguideChrome";

// Arbitrary-but-consistent styleguide stand-ins for the page-derived values
// the production component maps close over. Block content itself comes from
// the serialized fixture value, so these only affect incidental link targets.
const pageContext = {
    pageSlug: "contact-us",
    homeOprahChillUrl: "/mattresses/chill/",
    homeOprahClassicUrl: "/mattresses/classic/",
};

const registry = {
    toolbox: buildContextualToolboxComponentsMap(pageContext),
    home: buildHomePageComponentsMap(pageContext),
    offers: offersPageComponentsMap,
    compare_hero: compareHeroComponentsMap,
    compare_body: buildComparePageBodyComponentsMap(pageContext),
    product_page: buildProductPageBaseComponentsMap(pageContext),
    product_compare: buildProductComparePageComponentsMap(pageContext),
    financing: financingPageComponentsMap,
    faq: faqPageComponentsMap,
    reviews_right_bar: reviewsRightBarComponentsMap,
    footer: footerComponentsMap,
    configurator: configuratorPromoLineComponentsMap,
    promo_modal: promoModalComponentsMap,
};

const StyleguideBlocks = makeStyleguideTemplate(registry);

export const Template = (
    props: templates.StyleguideBlockTemplate,
): React.JSX.Element => {
    const inner = (
        <StyleguideBlocks
            block={props.block}
            map_key={props.map_key}
            bg_color={props.bg_color}
        />
    );
    return (
        <StyleguideChrome storybook={props.storybook}>
            {props.storybook ? inner : <div id="block-tester">{inner}</div>}
        </StyleguideChrome>
    );
};
